export const SUBMIT_WAITLIST_FORM_FAILED = 'SUBMIT_WAITLIST_FORM_FAILED';

export function submitWaitlistFormFailed(e) {
  return {
    type: SUBMIT_WAITLIST_FORM_FAILED,
    err: e,
  };
}



// WEBPACK FOOTER //
// ./src/actions/waitlist.js